/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryTransactionDto } from '../../models/inventory-transaction-dto';

export interface GetInventoryTransaction$Params {
  id: string;
}

export function getInventoryTransaction(http: HttpClient, rootUrl: string, params: GetInventoryTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryTransactionDto>> {
  const rb = new RequestBuilder(rootUrl, getInventoryTransaction.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryTransactionDto>;
    })
  );
}

getInventoryTransaction.PATH = '/v0/inventoryTransactions/{id}';
